import { render, staticRenderFns } from "./Paddle.vue?vue&type=template&id=9a54e534"
import script from "./Paddle.vue?vue&type=script&lang=js"
export * from "./Paddle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports